module.exports = __webpack_public_path__ + "img/advance-3-2.svg";